import _ from 'lodash';

import nonBusinessEmailList from './nonBusinessEmailList.json';
import { getCookie } from '../helpers/helpers';

export const SIGNUP_STEPS = [
    'stepZero',
    'businessIntroduction',
    'personalInformation',
    'checkEligibility',
    'businessAccounts',
    'myAccount'
];

export const NUMBER_OF_STEPS = SIGNUP_STEPS.length - 1;
export const ACCOUNT_PAGES_STEP_NUMBER = 100;
export const SIGNUP_STEP_COOKIE_NAME = 'latestActiveSignupStep';
export const LEAD_QUALITY_STORAGE_KEY = 'leadValue';

export const generateLatestActiveSignupStepCookie = ({
    latestSignupStep,
    daysTillExpiration = 1000
}) => {
    const cookieValue = latestSignupStep;

    const date = new Date();
    date.setTime(date.getTime() + daysTillExpiration * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();

    return (
        SIGNUP_STEP_COOKIE_NAME +
        '=' +
        cookieValue +
        ';' +
        expires +
        '; path=/;'
    );
};

export const getValueOfLatestActiveSignupStepCookie = () => {
    let latestActiveSignupStepCookieValue = getCookie(SIGNUP_STEP_COOKIE_NAME);

    if (
        !isNaN(latestActiveSignupStepCookieValue) &&
        latestActiveSignupStepCookieValue !== null
    ) {
        const clampedStepNumber = _.clamp(
            latestActiveSignupStepCookieValue,
            0,
            NUMBER_OF_STEPS
        );

        return SIGNUP_STEPS[clampedStepNumber];
    }

    if (!SIGNUP_STEPS.includes(latestActiveSignupStepCookieValue))
        return SIGNUP_STEPS[0];

    return latestActiveSignupStepCookieValue;
};

export const readFromLocalStorageByKey = (key) => {
    const localStorageValue = window.localStorage.getItem(key);
    if (!localStorageValue) return {};

    return JSON.parse(localStorageValue);
};

export const writeToLocalStorageByKey = (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

export const checkIsBusinessEmail = (email) => {
    const emailDomain = email.match(/.*\@(.*?)\..+/);
    if (emailDomain === null) return null;

    if (!nonBusinessEmailList[emailDomain[1].toLowerCase()]) return true;

    return false;
};

export const differenceInYearsFromNow = (date) => {
    const diff = new Date(Date.now() - date);
    return Math.abs(diff.getUTCFullYear() - 1970);
};

const LEAD_TIER_1 = 'Great Lead';
const LEAD_TIER_2 = 'Good Lead';
const LEAD_TIER_3 = 'Ok Lead';
const LEAD_TIER_4 = 'Poor Lead';
const LEAD_TIER_NA = 'N/A';

export function getStepLeadValue({ stepName, qualityIndicators }) {
    const { email, requestedAmount, tradingSince } = qualityIndicators;

    const isBusinessEmail = checkIsBusinessEmail(email);
    const tradingYears = differenceInYearsFromNow(new Date(tradingSince));

    if (isBusinessEmail === null) return LEAD_TIER_NA;

    switch (stepName) {
        case 'stepZero':
            if (isBusinessEmail && requestedAmount > 3000) return LEAD_TIER_2;
            if (!isBusinessEmail && requestedAmount > 5000) return LEAD_TIER_3;
            return LEAD_TIER_4;

        case 'businessIntroduction':
        case 'personalInformation':
            if (requestedAmount <= 3000 || tradingYears < 1) return LEAD_TIER_4;

            if (requestedAmount > 3000 && tradingYears === 1)
                return LEAD_TIER_3;

            if (
                !isBusinessEmail &&
                requestedAmount > 3000 &&
                tradingYears >= 2 &&
                tradingYears < 10
            )
                return LEAD_TIER_2;

            if (
                (requestedAmount > 3000 && tradingYears >= 10) ||
                (isBusinessEmail &&
                    requestedAmount > 3000 &&
                    tradingYears >= 2 &&
                    tradingYears < 10)
            )
                return LEAD_TIER_1;

            return LEAD_TIER_NA;

        default:
            return LEAD_TIER_NA;
    }
}
